import { createSelector } from 'reselect';
import { getAllSpaces } from 'spaces/store/selectors';
import Feed from 'feeds/containers/FeedWidget';
import Favorites from 'favorites/containers/Favorites';
import DefaultFavorites from 'favorites/containers/DefaultFavorites';
import AdwiredNewsWidget from 'news/containers/AdwiredNewsWidget';
import Welcome from '../../containers/widgets/Welcome';
import TutorialVideo from '../../containers/widgets/TutorialVideo';

// Minimal dashboard layout to be used as a fallback if a user has no dashboard assigned
export const minimalDashboard = {
  layout: {
    lg: [{
      w: 2, h: 7, x: 4, y: 5, i: 'feed', moved: false, static: false,
    }, {
      w: 4, h: 6, x: 0, y: 0, i: 'welcome', moved: false, static: false,
    }, {
      w: 2, h: 6, x: 2, y: 6, i: 'favorites', moved: false, static: false,
    }, {
      w: 2, h: 6, x: 0, y: 6, i: 'news', moved: false, static: false,
    }, {
      w: 2, h: 5, x: 4, y: 0, i: 'tutorial', moved: false, static: false,
    }],
    xxs: [{
      w: 1, h: 7, x: 0, y: 11, i: 'feed', moved: false, static: false,
    }, {
      w: 1, h: 6, x: 0, y: 0, i: 'welcome', moved: false, static: false,
    }, {
      w: 1, h: 6, x: 0, y: 18, i: 'favorites', moved: false, static: false,
    }, {
      w: 1, h: 6, x: 0, y: 24, i: 'news', moved: false, static: false,
    }, {
      w: 1, h: 5, x: 0, y: 6, i: 'tutorial', moved: false, static: false,
    }],
    md: [{
      w: 2, h: 7, x: 4, y: 5, i: 'feed', moved: false, static: false,
    }, {
      w: 4, h: 6, x: 0, y: 0, i: 'welcome', moved: false, static: false,
    }, {
      w: 2, h: 6, x: 2, y: 6, i: 'favorites', moved: false, static: false,
    }, {
      w: 2, h: 6, x: 0, y: 6, i: 'news', moved: false, static: false,
    }, {
      w: 2, h: 5, x: 4, y: 0, i: 'tutorial', moved: false, static: false,
    }],
    sm: [{
      w: 1, h: 9, x: 1, y: 0, i: 'feed', moved: false, static: false,
    }, {
      w: 1, h: 5, x: 0, y: 0, i: 'welcome', moved: false, static: false,
    }, {
      w: 1, h: 5, x: 0, y: 5, i: 'favorites', moved: false, static: false,
    }, {
      w: 1, h: 9, x: 1, y: 9, i: 'news', moved: false, static: false,
    }, {
      w: 1, h: 5, x: 0, y: 10, i: 'tutorial', moved: false, static: false,
    }],
  },
};

export const getMinimalDashboard = () => minimalDashboard;

export const getDashboardsById = (state) => state.entities.dashboards;

export const getBaseWidgets = () => [
  {
    id: 'feed',
    title: 'Recent Activity',
    width: 2,
    height: 6,
    component: Feed,
    componentProps: {
      spaceId: null,
    },
  },
  {
    id: 'welcome',
    title: 'Welcome',
    width: 4,
    height: 6,
    component: Welcome,
  },
  {
    id: 'favorites',
    title: 'My favorites',
    width: 2,
    height: 6,
    component: Favorites,
  },
  {
    id: 'defaultFavorites',
    title: 'Suggested favorites',
    width: 2,
    height: 6,
    component: DefaultFavorites,
  },
  {
    id: 'news',
    title: 'Bucher in the media',
    width: 2,
    height: 6,
    component: AdwiredNewsWidget,
  },
  {
    id: 'tutorial',
    title: 'Video Tutorial',
    width: 2,
    height: 5,
    component: TutorialVideo,
  },
];

const getSpaceWidgets = createSelector(
  [getAllSpaces],
  (spaces) => spaces.map((space) => ({
    id: `feed-space-${space.id}`,
    title: space.name,
    width: 2,
    height: 6,
    component: Feed,
    componentProps: {
      spaceId: space.id,
    },
  })),
);

export const getAllWidgets = createSelector(
  [getBaseWidgets, getSpaceWidgets],
  (baseWidgets, spaceWidgets) => [...baseWidgets, ...spaceWidgets],
);
